export const LAYOUT_ID_MINIMAL = 0;
export const LAYOUT_ID_EDITORIAL = 1;
export const LAYOUT_ID_POSTCARD = 2;
export const LAYOUT_ID_MAGAZINE = 3;
export const LAYOUT_ID_TILED = 4;
export const LAYOUT_ID_BRICK = 5;
export const LAYOUT_ID_SIDE_BY_SIDE = 6;
export const LAYOUT_ID_ONE_COLUMN = 7;
export const LAYOUT_ID_FULL_POST = 8;

export const LAYOUT_ID_DEFAULT = LAYOUT_ID_SIDE_BY_SIDE;

export const LAYOUT_NAME_MINIMAL = 'minimal';
export const LAYOUT_NAME_EDITORIAL = 'editorial';
export const LAYOUT_NAME_POSTCARD = 'postcard';
export const LAYOUT_NAME_MAGAZINE = 'magazine';
export const LAYOUT_NAME_TILED = 'tiled';
export const LAYOUT_NAME_BRICK = 'brick';
export const LAYOUT_NAME_SIDE_BY_SIDE = 'side-by-side';
export const LAYOUT_NAME_ONE_COLUMN = 'one-column';
export const LAYOUT_NAME_FULL_POST = 'full-post';
export const LAYOUT_NAME_MOBILE = 'mobile';
export const LAYOUT_NAME_MOBILE_TEXT_ON_IMAGE = 'mobile-text-on-image';

export const LAYOUT_NAMES = {
  [LAYOUT_ID_MINIMAL]: LAYOUT_NAME_MINIMAL,
  [LAYOUT_ID_EDITORIAL]: LAYOUT_NAME_EDITORIAL,
  [LAYOUT_ID_POSTCARD]: LAYOUT_NAME_POSTCARD,
  [LAYOUT_ID_MAGAZINE]: LAYOUT_NAME_MAGAZINE,
  [LAYOUT_ID_TILED]: LAYOUT_NAME_TILED,
  [LAYOUT_ID_BRICK]: LAYOUT_NAME_BRICK,
  [LAYOUT_ID_SIDE_BY_SIDE]: LAYOUT_NAME_SIDE_BY_SIDE,
  [LAYOUT_ID_ONE_COLUMN]: LAYOUT_NAME_ONE_COLUMN,
  [LAYOUT_ID_FULL_POST]: LAYOUT_NAME_FULL_POST,
};

export const getLayoutName = id => LAYOUT_NAMES[id];

export const POST_LIMIT_TYPE_ID_ALL_POSTS = 0;
export const POST_LIMIT_TYPE_ID_NUMBER_OF_POSTS = 1;

export const POST_LIMIT_TYPE_NAME_ALL_POSTS = 'Show all your posts';
export const POST_LIMIT_TYPE_NAME_NUMBER_OF_POSTS = 'Set number of posts to show';

export const POST_LIMIT_TYPES = {
  [POST_LIMIT_TYPE_ID_ALL_POSTS]: POST_LIMIT_TYPE_NAME_ALL_POSTS,
  [POST_LIMIT_TYPE_ID_NUMBER_OF_POSTS]: POST_LIMIT_TYPE_NAME_NUMBER_OF_POSTS,
};

export const getPostLimitTypeName = id => POST_LIMIT_TYPES[id];

export const isAuthorImageSupported = layoutId =>
  ![LAYOUT_ID_MINIMAL, LAYOUT_ID_POSTCARD, LAYOUT_ID_MAGAZINE].includes(layoutId);

export const isAuthorInfoSupported = layoutId => layoutId !== LAYOUT_ID_MINIMAL;
